import { createContext as t } from "react";
import { DEFAULT_SEVERITY as e } from "./utils.js";
const m = t({
  severity: e
});
export {
  m as AlertContext
};
